import { render } from "./DropDownMenu.vue?vue&type=template&id=713110a1&scoped=true&ts=true"
import script from "./DropDownMenu.vue?vue&type=script&lang=ts"
export * from "./DropDownMenu.vue?vue&type=script&lang=ts"

import "./DropDownMenu.vue?vue&type=style&index=0&id=713110a1&lang=scss&scoped=true"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-713110a1"]])

export default __exports__